import { NgModule } from '@angular/core';
import { JssModule } from '@sitecore-jss/sitecore-jss-angular';
import { KioskInsuranceClerksComponent } from './kiosk-insurance-clerks.component';
import { AppComponentsSharedModule } from '../app-components.shared.module';

@NgModule({
  imports: [
    JssModule.forChild(KioskInsuranceClerksComponent),
    AppComponentsSharedModule
  ],
  declarations: [
    KioskInsuranceClerksComponent
  ],
})
export class KioskInsuranceClerksModule { }
